import { Chip, useTheme } from '@mui/material';
import { CheckCheck, CircleDashed, Clock } from 'lucide-react';

import { useLocale } from '@shared/hooks/locale';

// Status badge — same recipe as the /dashboard PublishedChip: subtle color-mix
// tint + the palette's dark shade as text, read through theme vars so both
// color schemes stay readable.
const chipSx = (main: string, dark: string) => ({
  fontWeight: 600,
  fontSize: '0.75rem',
  height: 22,
  borderRadius: '6px',
  '& .MuiChip-icon': { ml: 0.5, mr: -0.25, fontSize: 14, color: 'inherit' },
  bgcolor: `color-mix(in srgb, ${main} 8%, transparent)`,
  color: dark,
});

// email_campaigns_status_enum: 'done' | 'pending'. NULL = campaigns sent
// before the status column existed (2023) — neutral, not an error.
export const CampaignStatusChip = ({
  status,
}: {
  status: string | null | undefined;
}) => {
  const { t } = useLocale();
  const theme = useTheme();
  const palette = (theme.vars ?? theme).palette;

  if (status === 'done') {
    return (
      <Chip
        size="small"
        icon={<CheckCheck size={14} strokeWidth={2.5} />}
        label={t('done')}
        sx={chipSx(palette.success.main, palette.success.dark)}
      />
    );
  }
  if (status === 'pending') {
    return (
      <Chip
        size="small"
        icon={<Clock size={14} strokeWidth={2.5} />}
        label={t('pending')}
        sx={chipSx(palette.warning.main, palette.warning.dark)}
      />
    );
  }
  return (
    <Chip
      size="small"
      icon={<CircleDashed size={14} strokeWidth={2.5} />}
      label={t('Unknown')}
      sx={chipSx(palette.grey[500], palette.grey[600])}
    />
  );
};
